import React from 'react';
import CabCrudPage from './CabCrudPage';

const AdminCabsAmenities = () => (
  <CabCrudPage
    title="Amenities"
    description="Manage cab amenity options and tags."
    resource="amenities"
    defaultItem={{
      name: '',
      slug: '',
      category: '',
      description: '',
      icon: '',
      isActive: true,
    }}
    columns={[
      { key: 'name', label: 'Name' },
      { key: 'slug', label: 'Slug' },
      { key: 'category', label: 'Category' },
    ]}
    fields={[
      { name: 'name', label: 'Name', required: true },
      { name: 'slug', label: 'Slug', required: true },
      { name: 'category', label: 'Category' },
      { name: 'icon', label: 'Icon key' },
      { name: 'description', label: 'Description', type: 'textarea', col: 'col-12' },
      { name: 'isActive', label: 'Active', type: 'checkbox', col: 'col-md-6' },
    ]}
  />
);

export default AdminCabsAmenities;
